import { getAnalytics, isSupported } from 'firebase/analytics';
import { getApp, getApps, initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

let analytics: ReturnType<typeof getAnalytics> | null = null;

/**
 * Resolves once Firebase analytics is either initialized (supported environment) or
 * determined to be unsupported. Callers can defer events that fire while `isSupported()`
 * is still pending — otherwise events sent during early app bootstrap (e.g. the token-link
 * auto-login dispatching `trackLogin('token')` the moment App mounts) would be silently
 * dropped by the `if (!analytics)` guard in `useAnalytics`.
 */
export const analyticsReady: Promise<ReturnType<typeof getAnalytics> | null> = isSupported().then(
  (ok) => {
    if (ok && typeof window !== 'undefined') {
      analytics = getAnalytics(app);
    }
    return analytics;
  }
);

export { analytics };
